import {
  type PricelistProductBulkCreateInput,
  usePricelistProductBulkCreateMutation,
} from "@/generated/graphql";

export const usePricelistProductBulkCreate = () => {
  const [, bulkCreatePricelistProductMutation] =
    usePricelistProductBulkCreateMutation();

  const bulkCreatePricelistProduct = (
    input: PricelistProductBulkCreateInput
  ) => {
    return bulkCreatePricelistProductMutation({ input });
  };

  return {
    bulkCreatePricelistProduct,
  };
};
